export default __webpack_public_path__ + "static/media/b-10.e8944d5d.jpg";